import { InjectionToken } from '@angular/core';

export interface SatisfactionSurveyApiConfig {
  apiBaseUrl: string;
  survey: {
    propertyCode: string;
    useEntrySession: boolean;
  };
}

export const SATISFACTION_SURVEY_API_CONFIG =
  new InjectionToken<SatisfactionSurveyApiConfig>(
    'SATISFACTION_SURVEY_API_CONFIG',
    {
      factory: () => ({
        apiBaseUrl: 'https://surveyapi-dev.cieneguillariberadelrio.com/api/v1',
        survey: {
          propertyCode: 'ribera-cieneguilla',
          useEntrySession: false,
        },
      }),
    }
  );
